import React from "react";
import classNames from "classnames";
import { RadioButtonProps } from "./types";
import { ConnectForm } from "@/utils/formHelper";
import "./styles.scss";

export const RadioButton = ({
  id,
  dataQA,
  name,
  error,
  success,
  disabled,
  defaultChecked,
  className,
  value,
  checked,
  readOnly,
}: RadioButtonProps) => {
  const classnames = classNames(`RadioButton`, {
    className: className,
    "RadioButton--error": error,
    "RadioButton--success": success,
    "RadioButton--disabled": disabled,
  });

  return (
    <div
      data-testid="RadioButton"
      data-qa={dataQA}
      className={classnames}>
      <ConnectForm>
        <div className="RadioButton-container">
          <input
            type="radio"
            id={id}
            name={name}
            className="plan-box__title__radio"
            value={value}
            checked={checked || defaultChecked}
            readOnly={readOnly}
            aria-label="plan"
          />
          <span className="checkmark"></span>
        </div>
      </ConnectForm>
    </div>
  );
};
